import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


const AR_VALIDATION:any = {
  'email': 'البريد الإلكتروني',
  'password': 'كلمة المرور',
  'name': 'الاسم',
  'mobile': 'الهاتف',
  'title': 'العنوان',
  'description': 'الوصف',
  'parent':'الخدمة الرئيسة',
  'discount':'الخصم غير متاح'
}


@Injectable({
  providedIn: 'root'
})
export class UiHelperService {

  constructor(private toastr: ToastrService) { }

  toastrSuccess(msg: string, title: string = '') {
    if (title != '') this.toastr.success(msg, title, {
      closeButton: true,
    });
    else this.toastr.success(msg);
  }

  toastrError(msg: string, title: string = '') {
    if (title != '') this.toastr.error(msg, title,{
      closeButton:true,
    });
    else this.toastr.error(msg);
  }

  showErrors(errors: any) {
    const currentLang = localStorage.getItem('language')
    errors.forEach((err: any) => {  
      this.toastrError(err.message, currentLang == 'ar' ? AR_VALIDATION[err.path[0]] : err.path[0]);
    });
  }

  toastrWarning(msg: string, title: string = '') {
    if (title != '') this.toastr.warning(msg, title,{
      closeButton:true
    });
    else this.toastr.warning(msg);
  }

  toastrInfo(msg: string, title: string = '') {
    if (title != '') this.toastr.info(msg, title,{
      closeButton:true
    });
    else this.toastr.info(msg);
  }

  setParam(key:string, value:any){ // set something to localstorage
    const JSONValue = JSON.stringify(value)
     localStorage.setItem(key,JSONValue)
  }

  getParam<T>(key:string) : T | null { //get somthing from localstorage based on the given type
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) return null;

    try {
      return JSON.parse(storedValue);
    } catch (error) {
      return null;
    }

  }

  removeParam(key:string){ // remove something to localstorage
    localStorage.removeItem(key)
  }
}
